export default "__VITE_ASSET__NLoMNBvq__"